module.exports = __webpack_public_path__ + "static/sui-menu-a5e36a3a771b1e450314e72ef9b62342.png";